import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  class: "feedback text-primary",
  id: "feedback"
}
const _hoisted_2 = {
  key: 0,
  class: "text-pagesubtitle feedback-title"
}
const _hoisted_3 = {
  key: 0,
  class: "text-paragraph feedback-text"
}
const _hoisted_4 = {
  key: 2,
  class: "app-card text-center feedback-card"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-header feedback-card-title" }
const _hoisted_7 = { class: "text-label text-primary50 m-0" }
const _hoisted_8 = {
  key: 0,
  class: "text-paragraph text-start feedback-text"
}
const _hoisted_9 = {
  key: 3,
  class: "feedback-actions"
}

import { computed, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import AppSection from "@/components/app/AppSection.vue";
import AppYesNo from "@/components/app/AppYesNo.vue";
import { useSilentErrors, useVeeField } from "@/composables/useVeeField";
import { ratingRepo } from "@/di/repositories";
import { feedbackSchema, toCallRatingBody } from "@/schemas/feedback";
import { EventBus, EventBusNames } from "@/utils/EventBus";

// `showTitle`: no fim da chamada a tela é cheia; no detalhe da sessão o título fica no modal

export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackDetail',
  props: {
    appointment: {},
    showTitle: { type: Boolean, default: false }
  },
  emits: ["onRatingFinished"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;

const rating = computed(() => props.appointment?.my_rating);
const readonly = computed(() => !!rating.value);

const { handleSubmit, meta, values, setFieldValue } = useForm({
  validationSchema: toTypedSchema(feedbackSchema),
  initialValues: { trouble: false, description: "", call_completed: true, testimonial: "" },
});
useVeeField<boolean>("trouble");
useVeeField<boolean>("call_completed");
const descriptionModel = useVeeField("description");
const testimonialModel = useVeeField("testimonial");
const silentErrors = useSilentErrors(feedbackSchema, values);

// respostas mostradas: as da avaliação feita ou as do formulário
const answers = computed(() =>
  readonly.value
    ? { trouble: !!rating.value?.trouble, call_completed: !!rating.value?.call_completed }
    : { trouble: !!values.trouble, call_completed: !!values.call_completed },
);
const handleTrouble = (trouble: boolean) => !readonly.value && setFieldValue("trouble", trouble);
const handleCallCompleted = (completed: boolean) => !readonly.value && setFieldValue("call_completed", completed);

const submitting = ref(false);
const handleSendFeedback = handleSubmit(async (v) => {
  if (!props.appointment) return;
  try {
    submitting.value = true;
    const res: any = await ratingRepo.createCallRating(toCallRatingBody(v, props.appointment.id) as any);
    if (res?.status !== false) {
      emit("onRatingFinished");
      EventBus.$emit(EventBusNames.REFRESH_APPOINTMENT);
      EventBus.$emit(EventBusNames.SHOW_TOAST, {
        title: "Depoimento enviado",
        msg: "Seu depoimento foi enviada e está sendo analizada",
      });
    }
  } catch (error: any) {
    EventBus.$emit(EventBusNames.SHOW_ERROR_TOAST, { msg: error.message });
  } finally {
    submitting.value = false;
  }
});

__expose({ handleSendFeedback });

return (_ctx: any,_cache: any) => {
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Como foi sua sessão"))
      : _createCommentVNode("", true),
    _createVNode(AppSection, {
      title: "Teve algum problema técnico?",
      class: "pt-0"
    }, {
      default: _withCtx(() => [
        _createVNode(AppYesNo, {
          modelValue: answers.value.trouble,
          disabled: readonly.value,
          idPrefix: "feedback-trouble",
          "onUpdate:modelValue": handleTrouble
        }, null, 8, ["modelValue", "disabled"]),
        (readonly.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(rating.value?.description), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(descriptionModel).$model) = $event)),
              class: "feedback-input text-paragraph",
              id: "feedback-description",
              type: "text",
              maxlength: 200,
              placeholder: "Gostaria de fazer algum comentário?"
            }, null, 512)), [
              [
                _vModelText,
                _unref(descriptionModel).$model,
                void 0,
                { trim: true }
              ]
            ])
      ]),
      _: 1
    }),
    (answers.value.trouble)
      ? (_openBlock(), _createBlock(AppSection, {
          key: 1,
          title: "Conseguiu realizar a sessão?"
        }, {
          default: _withCtx(() => [
            _createVNode(AppYesNo, {
              modelValue: answers.value.call_completed,
              disabled: readonly.value,
              idPrefix: "feedback-completed",
              "onUpdate:modelValue": handleCallCompleted
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (answers.value.call_completed || !answers.value.trouble)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: __props.appointment?.psychologist?.formatted_profile_image,
            alt: "",
            class: "rounded-circle feedback-avatar"
          }, null, 8, _hoisted_5),
          _createElementVNode("p", _hoisted_6, [
            _cache[3] || (_cache[3] = _createTextVNode(" Deixe um depoimento para", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(_toDisplayString(__props.appointment?.psychologist?.name), 1)
          ]),
          _createElementVNode("p", _hoisted_7, "CRP: " + _toDisplayString(__props.appointment?.psychologist?.crp), 1),
          _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "app-divider feedback-card-divider" }, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-subtitle text-start m-0" }, "Gostaria de deixar um depoimento?", -1)),
          (readonly.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(rating.value?.testimonial || "N/A"), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(testimonialModel).$model) = $event)),
                class: "feedback-input text-paragraph",
                id: "feedback-testimonial",
                type: "text",
                maxlength: 200,
                placeholder: "Descreva aqui"
              }, null, 512)), [
                [
                  _vModelText,
                  _unref(testimonialModel).$model,
                  void 0,
                  { trim: true }
                ]
              ])
        ]))
      : _createCommentVNode("", true),
    (!readonly.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_FormButton, {
            app: "",
            id: "feedback-submit",
            label: "Enviar avaliação",
            disabled: !_unref(meta).valid,
            form: _unref(silentErrors),
            loading: submitting.value,
            marginVertical: false,
            onOnClick: _unref(handleSendFeedback)
          }, null, 8, ["disabled", "form", "loading", "onOnClick"]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-app btn-app-outline",
            id: "feedback-skip",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('onRatingFinished')))
          }, "Pular")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})